module.exports = __webpack_public_path__ + "static/media/companyLogo.1dc693ff.svg";